<style>

</style>

<div class="message">{messages[ curMessage ]}</div>

<script>

export let curMessage = 0;

let messages = [
  "Loading Awesome Sauce",
  "Gathering Fun Stuff",
  "Retrieving Cool People",
  "Almost There",
]


</script>